import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Home, User, Heart } from 'lucide-react';
import { SearchBar } from '../search/SearchBar';
import { GoogleTranslate } from '../common/GoogleTranslate';


const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1000;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    display: none;
  }
`;

const Logo = styled(Link)`
  font-size: 1.5rem;
  font-weight: bold;
  color: #FFD700;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #FFF;
  }
`;

const CenterSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const SearchAndUserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const NavLink = styled(Link)<{ $active?: boolean }>`
  color: ${props => props.$active ? '#FFD700' : '#FFFFFF99'};
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  transition: all 0.2s;
  padding: 0.5rem;
  border-radius: 4px;
  position: relative;

  &:hover {
    color: #FFFFFF;
    background: rgba(255, 255, 255, 0.1);
  }

  ${props => props.$active && `
    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 0.5rem;
      right: 0.5rem;
      height: 2px;
      background: #FFD700;
      border-radius: 2px;
    }
  `}
`;

const TopNavbar: React.FC = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <Nav>
      <Logo to="/">Cinédelux</Logo>
      <CenterSection>
        <NavLinks>
          <NavLink 
            to="/" 
            $active={isActive('/')}
          >
            <Home size={20} />
            Accueil
          </NavLink>
          <NavLink 
            to="/browse" 
            $active={isActive('/browse')}
          >
            Films
          </NavLink>
          <NavLink 
            to="/blog" 
            $active={isActive('/blog')}
          >
            Blog
          </NavLink>
        </NavLinks>

        <SearchAndUserSection>
          <NavLink to="/profile">
            <User size={20} />
            Profile
          </NavLink>

          <NavLink to="/watchlist">
            <Heart size={20} />
            Ma Liste
          </NavLink>

          <SearchBar />

          <GoogleTranslate />
        </SearchAndUserSection>
      </CenterSection>
    </Nav>
  );
};

export default TopNavbar;
